import { createContext, useContext, ReactNode } from "react";
import useYandexMetrika from "@/hooks/useYandexMetrika";

interface YandexMetrikaContextType {
  reachGoal: (target: string, params?: Record<string, unknown>) => void;
  hit: (url?: string, options?: Record<string, unknown>) => void;
  params: (parameters: Record<string, unknown>) => void;
  userParams: (parameters: Record<string, unknown>) => void;
}

const YandexMetrikaContext = createContext<YandexMetrikaContextType | null>(null);

interface YandexMetrikaProviderProps {
  children: ReactNode;
  counterId?: number;
}

export const YandexMetrikaProvider = ({ children, counterId }: YandexMetrikaProviderProps) => {
  const metrika = useYandexMetrika(counterId);

  return <YandexMetrikaContext.Provider value={metrika}>{children}</YandexMetrikaContext.Provider>;
};

export const useYandexMetrikaContext = () => {
  const context = useContext(YandexMetrikaContext);
  if (!context) {
    console.warn("useYandexMetrikaContext должен использоваться внутри YandexMetrikaProvider");
    return {
      reachGoal: () => {},
      hit: () => {},
      params: () => {},
      userParams: () => {},
    };
  }
  return context;
};

export default YandexMetrikaContext;
